import React from "react";
import "../PrivacyPolicy/PrivacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <>
      <div className="full-privacy">
        <section className="privacy-policy">
          <h1>Privacy Policy</h1>
          <p>
            At Journey Experts we understand and respect the importance of your privacy and we are dedicated to
safeguarding and preserving your privacy and personal information when visiting our site or
communicating electronically with us. In providing our service to you, we must collect personal information
from you and this Policy outlines how we treat your personal data after it has been collected by any of our
channels, which includes our website. Our Data Protection and Privacy Policy provides an explanation as to what happens to any personal data
that you provide to us.
          </p>
          <h2>What information will we collect?</h2>
          <p>
           In operating our website we may collect and process all or some of the following data about you:
          </p>
          <ul>
            <li>
              Names and contact/address details including telephone number and email address.

            </li>
            <li>
             Details of your visits to our website and the resources that you access, including, but not limited
to, traffic data, location data, weblogs and other communication data.
            </li>
            <li>
             Information that you provide by filling in forms on our website, such as when you registered for
information or make a purchase.
            </li>
            <li>Information provided to us when you communicate with us for any reason.
</li>
          </ul>
          <p>
            From time to time some of the information which we collect may be considered a sensitive personal data
under the Data Protection Act 1998. We collect it to cater to your needs or act in your interest, and we are
only prepared to accept sensitive personal data from you on the condition that we have your positive
consent. We will seek this consent when necessary.

          </p>

          <h2>How will we collect this information?
</h2>
          <p>
            We will only collect personal information from you by specifically asking for it, for example:
          </p>
          <ul>
            <li>When you purchase a service from us;</li>
            <li>When you subscribe to any newsletter which we may offer from time to time;
</li>
            <li>When you register an account with us;
</li>
            <li>When you speak to our customer services team;</li>
          </ul>

          <h2>What will we do with it?</h2>
         
          <ul>
            <li>
             We will use your name, address and payment details to complete your purchase with us.

            </li>
            <li>We will also use your details to manage your arrangements, send you notifications and
communicate with you generally.</li>
            <li>We may have to disclose your information to the advertisers on our website (who could be
located outside the UK/EEA). Please be advised that we do not reveal information about
identifiable individuals to our advertisers but we may, on occasion, provide them with aggregate
statistical information about our visitors.</li>
            <li>
             For the purpose of providing you with the consignment services, we may have to disclose some
of your information to the providers of the services making up your consignment (who could be
located outside the UK/EEA). We may also have to disclose some information to third parties in
relation to customer services, credit card processing, or other services.
            </li>
            <li>
            We may need to disclose your information where required by law, where such a request is made
by a legal authority.
            </li>
            <li>
              We may from time to time contact you with information about special offers, brochures, new
products, forthcoming events or competitions. If you do not wish to receive such information, you
may ask us in writing not to receive it.
            </li>
            <li>
              We may pass your details to other parties who offer goods or services which we feel may be of
interest to you. If you do not wish to have your details passed on in this way, you may ask us in
writing not to do so. Please note, if you are a new customer we will only contact you or allow third
parties to contact you only when you have provided consent and only by those means you
provided consent for.
            </li>
            <li>
              We may need to disclose our customer list including any personal information relating to you to a
third party who acquires or attempts to acquire all or substantially all of the asset/ stock in our
company or our website.

            </li>
          </ul>

          <h2>Storing your personal data</h2>
          <p>
            We may transfer data that we collect from you to locations outside of the European Economic Area for
processing and storing. Also, it may be processed by staff operating outside the European Economic
Area who works for us or for one of our suppliers. For example, such staff maybe engaged in the
processing and concluding of your order, the processing of your payment details and the provision of
support services. Outside the European Economic Area, controls on data protection may not be as wide
as the legal requirements in this country. By submitting your personal data, you agree to this transfer,
storing or processing. We will take all reasonable steps to make sure that your data is treated securely
and in agreement with this Privacy Policy.
          </p>
          <p>
            Data that is provided to us is stored on our secure servers. Details relating to any transactions entered
into on our site will be encrypted to ensure its safety.

          </p>
          <p>
            The transmission of information via the Internet is not completely secure and therefore we cannot
guarantee the security of data sent to us electronically and transmission of such data is therefore entirely
at your own risk. Where we have given you (or where you have chosen) a password so that you can
access certain parts of our site, you are responsible for keeping this password confidential.
          </p>

          <h2>What can I do?</h2>
          <p>
            If you do not agree to our use of the information as set out above, you should inform us as soon as
possible by writing to us at
          </p>
          <address>
           <strong>Journey Experts Ltd of Kemp House, 152-160 City Road London </strong> or by email a <strong>email@journeyexperts.co.uk</strong>
          </address>
          <p>
          In accordance with the Data Protection Act 1998, you may ask us in writing for a copy of the information
we hold about you (for which we may charge an administration fee) and to correct any inaccuracies in
your information. We aim to respond to you within 24 days from the date of request.

          </p>
          <p>
            You can also choose not to provide us with some of the information we request, however as a result we
may not be able to complete your arrangements.
          </p>

          <h2>Information collected by Third Parties
</h2>
          <p>
            In addition to information collected by ourselves we may also receive data that has been collected by third
parties, which would be added to the previous information held by ourselves and handled / stored in
accordance with this Policy.
          </p>

          <h2>Protecting your information</h2>
          <p>
            We take website security very seriously and we are committed to safeguarding your personal information.
We take a number of administrative and technical steps to ensure the security of the information you
provide to us.
          </p>

          <h2>External Links</h2>
          <p>
           Please note that our website may contain certain literature and hyperlinks to websites owned by third
parties. This Privacy Policy covers websites owned and controlled by us only. Links to other websites and
any information collected by these sites are not covered by this Privacy Policy.

          </p>

          <h2>Monitoring</h2>
<p>To ensure that we carry out your instructions accurately, to help improve our service and in the
interest of security, we may monitor and/or record: (1) your telephone calls; and (2) customer transactions
and activities on our website. All recordings are and shall remain our sole property.</p>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about privacy please contact us at by email <strong>info@journeyexperts.co.uk</strong> or by phone <strong>020 8144 3579</strong> .
          </p>
         
            
        

          <h2>Updates and Changes</h2>
          <p>
           As our privacy statement may change due to developments in the law we encourage you to re-read this
from time to time so you are aware of any changes in how we gather and use your personal information.
Any changes to this Policy will be either posted on our website, brochure and/or made available on
request.
          </p>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
